(function () {
  function pad2(value) {
    return String(value).padStart(2, '0');
  }

  function pad3(value) {
    return String(value).padStart(3, '0');
  }

  function getEndDate(root) {
    var month = parseInt(root.getAttribute('data-end-month'), 10);
    var day = parseInt(root.getAttribute('data-end-day'), 10);
    var hour = parseInt(root.getAttribute('data-end-hour'), 10) || 0;
    var minute = parseInt(root.getAttribute('data-end-minute'), 10) || 0;
    var second = parseInt(root.getAttribute('data-end-second'), 10) || 0;
    var yearAttr = parseInt(root.getAttribute('data-end-year'), 10);
    if (!month || !day) return null;

    var now = new Date();
    var year = yearAttr || now.getFullYear();
    var endDate = new Date(year, month - 1, day, hour, minute, second, 0);
    if (!yearAttr && now.getTime() > endDate.getTime()) {
      endDate = new Date(year + 1, month - 1, day, hour, minute, second, 0);
    }
    return endDate;
  }

  function updateRoot(root) {
    var daysEl = root.querySelector('[data-copa-days]');
    var hoursEl = root.querySelector('[data-copa-hours]');
    var minutesEl = root.querySelector('[data-copa-minutes]');
    var secondsEl = root.querySelector('[data-copa-seconds]');
    var msEl = root.querySelector('[data-copa-milliseconds]');
    if (!daysEl || !hoursEl || !minutesEl || !secondsEl || !msEl) return;

    var endDate = getEndDate(root);
    if (!endDate || Number.isNaN(endDate.getTime())) return;

    var diff = endDate.getTime() - new Date().getTime();
    if (diff <= 0) {
      root.style.display = 'none';
      return;
    }

    var dayMs = 86400000;
    var hourMs = 3600000;
    var minuteMs = 60000;
    var secondMs = 1000;

    daysEl.textContent = pad2(Math.floor(diff / dayMs));
    hoursEl.textContent = pad2(Math.floor((diff % dayMs) / hourMs));
    minutesEl.textContent = pad2(Math.floor((diff % hourMs) / minuteMs));
    secondsEl.textContent = pad2(Math.floor((diff % minuteMs) / secondMs));
    msEl.textContent = pad3(diff % secondMs);
  }

  function init() {
    document.querySelectorAll('[data-copa-countdown]').forEach(updateRoot);
    setInterval(function () {
      document.querySelectorAll('[data-copa-countdown]').forEach(updateRoot);
    }, 10);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
